module.exports = __webpack_public_path__ + "img/MDStock.38c4c3f9.png";